import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Flex, Box, Copy } from '@elparking/components'
import { FormattedMessage } from 'react-intl'

import { STATUS_AVAILABLE } from 'commons/js/constants'

import { SubmitButton } from 'parking-availability/js/ui/Button'
import BookingProductsList from 'parking-availability/js/components/BookingProductsList'
import { byPriceAsc } from 'parking-availability/js/util/comparators'
import { BookingProductType } from 'parking-availability/js/propTypes'

const hasUnavailableProducts = (bookingProducts) => bookingProducts.length > 0

class BookingProductsModalContent extends Component {
    static propTypes = {
        selectedBookingProduct: BookingProductType,
        bookingProducts: PropTypes.arrayOf(BookingProductType).isRequired,
        onSubmit: PropTypes.func,
    }

    static defaultProps = {
        onSubmit: () => {},
    }

    state = {
        selectedBookingProduct: this.props.selectedBookingProduct,
    }

    onClick = this.onClick.bind(this)

    onClick (bookingProduct) {
        this.setState(() => ({ selectedBookingProduct: bookingProduct }))
    }

    onSubmit = this.onSubmit.bind(this)

    onSubmit () {
        this.props.onSubmit(this.state.selectedBookingProduct)
    }

    render () {
        const { bookingProducts } = this.props
        const { selectedBookingProduct } = this.state

        const availableProducts = bookingProducts.filter(({ availability }) => availability.availabilityStatus === STATUS_AVAILABLE).sort(byPriceAsc)
        const unavailableProducts = bookingProducts.filter(({ availability }) => availability.availabilityStatus !== STATUS_AVAILABLE)

        return (
            <Flex flexWrap='wrap' p={['2em 0', '2em']}>
                <Box w='100%' mb='1.5em' px='1.5em'>
                    <Copy padding='0' size='xLarge' fontWeight='book' align='center'>
                        <FormattedMessage
                          defaultMessage='Elige la tarifa que mejor se adapta a ti'
                        />
                    </Copy>
                </Box>
                <Box w='100%' mb='2em'>
                    <BookingProductsList
                      bookingProducts={availableProducts}
                      selectedBookingProduct={selectedBookingProduct}
                      onClick={this.onClick}
                    />
                </Box>
                {hasUnavailableProducts(unavailableProducts) && <Box w='100%' mb='1em'>
                    <Box mb='1em'>
                        <Copy as='span' padding='0' size='small' fontWeight='regular'>
                            <FormattedMessage
                              defaultMessage='Tarifas no disponibles para tu selección:'
                            />
                        </Copy>
                    </Box>
                    <BookingProductsList
                      bookingProducts={unavailableProducts}
                      selectedBookingProduct={selectedBookingProduct}
                      isDisabled
                    />
                </Box>}
                <Box w='100%'>
                    <SubmitButton
                      width='100%'
                      loading={false}
                      onClick={this.onSubmit}
                    >
                        <Copy as='span' padding='0' fontWeight='medium' size='medium' color='white'>
                            <FormattedMessage
                              defaultMessage='Confirmar tarifa'
                            />
                        </Copy>
                    </SubmitButton>
                </Box>
            </Flex>
        )
    }
}

export default BookingProductsModalContent
